export default {
    SuperAdmin: 'Super Admin',
    Admin: 'Admin',
    SchoolAdmin: 'School Admin',
    Teacher: 'Teacher'
}